module.exports = __webpack_public_path__ + "static/media/ecommerce-img-02.3bfe0ed5.png";